import React, { Component } from "react";
import {
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid as Container,
  Row,
  Table
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import ViewportAlert from "components/ViewportAlert/ViewportAlert";

const API_BASE = "https://hgsystem.pl/mangusta";

class Statistics extends Component {
  state = {
    period: "24h",
    loading: false,
    error: "",
    summary: {},
    loginSummary: {},
    devices: [],
    loginUsers: [],
    loginDaily: [],
    deviceSortKey: "last_seen",
    deviceSortDirection: "desc"
  };

  componentDidMount() {
    this.loadStatistics();
  }

  post = body =>
    fetch(`${API_BASE}/admin_statistics.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        auth: this.props.adminCredentials,
        ...body
      })
    }).then(async response => {
      const data = await response.json();
      if (!response.ok)
        throw new Error(data.error || "Nie udało się pobrać statystyk");
      return data;
    });

  loadStatistics = () => {
    if (!this.props.adminCredentials) {
      this.setState({ error: "Brak uprawnień administratora" });
      return;
    }

    this.setState({ loading: true, error: "" });
    this.post({ period: this.state.period })
      .then(data =>
        this.setState({
          loading: false,
          summary: data.summary || {},
          loginSummary: data.login_summary || {},
          devices: Array.isArray(data.devices) ? data.devices : [],
          loginUsers: Array.isArray(data.login_users)
            ? data.login_users
            : [],
          loginDaily: Array.isArray(data.login_daily)
            ? data.login_daily
            : []
        })
      )
      .catch(error =>
        this.setState({ loading: false, error: error.message })
      );
  };

  changePeriod = event => {
    this.setState({ period: event.target.value }, this.loadStatistics);
  };

  formatNumber = value => {
    const number = Number(value);
    if (!Number.isFinite(number)) return "—";
    return new Intl.NumberFormat("pl-PL").format(number);
  };

  formatDecimal = (value, suffix) => {
    const number = Number(value);
    if (!Number.isFinite(number)) return "—";
    return `${number.toLocaleString("pl-PL", {
      maximumFractionDigits: 1
    })}${suffix || ""}`;
  };

  formatDate = value => {
    if (value === null || value === undefined || value === "") return "—";
    const text = String(value);
    const date = /^\d+$/.test(text)
      ? new Date(Number(text) * 1000)
      : new Date(`${text.replace(" ", "T")}Z`);
    return Number.isNaN(date.getTime())
      ? "—"
      : date.toLocaleString("pl-PL");
  };

  formatUptime = value => {
    const ticks = Number(value);
    if (!Number.isFinite(ticks) || ticks < 0) return "—";
    const seconds = Math.floor(ticks * 30);
    const days = Math.floor(seconds / 86400);
    const hours = Math.floor((seconds % 86400) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    if (days > 0) return `${days} d ${hours} h`;
    if (hours > 0) return `${hours} h ${minutes} min`;
    return `${minutes} min`;
  };

  changeDeviceSort = key => {
    this.setState(previousState => ({
      deviceSortKey: key,
      deviceSortDirection:
        previousState.deviceSortKey === key &&
        previousState.deviceSortDirection === "asc"
          ? "desc"
          : "asc"
    }));
  };

  deviceSortValue = (device, key) => {
    if (key === "device")
      return `${device.desc || ""} ${device.id || ""}`.trim();
    return Number(device[key]) || 0;
  };

  sortedDevices = () => {
    const { deviceSortKey, deviceSortDirection } = this.state;
    const direction = deviceSortDirection === "desc" ? -1 : 1;
    return this.state.devices.slice().sort((left, right) => {
      const leftValue = this.deviceSortValue(left, deviceSortKey);
      const rightValue = this.deviceSortValue(right, deviceSortKey);
      const comparison =
        typeof leftValue === "number" && typeof rightValue === "number"
          ? leftValue - rightValue
          : String(leftValue).localeCompare(String(rightValue), "pl", {
              sensitivity: "base",
              numeric: true
            });
      return comparison * direction;
    });
  };

  sortableDeviceHeader = (label, key) => {
    const active = this.state.deviceSortKey === key;
    const arrow = active
      ? this.state.deviceSortDirection === "asc"
        ? " ▲"
        : " ▼"
      : "";
    return (
      <th>
        <button
          type="button"
          onClick={() => this.changeDeviceSort(key)}
          style={{
            border: 0,
            padding: 0,
            background: "transparent",
            font: "inherit",
            fontWeight: "bold",
            cursor: "pointer",
            whiteSpace: "nowrap"
          }}
        >
          {label}
          {arrow}
        </button>
      </th>
    );
  };

  renderMetric(title, value, category) {
    return (
      <Col lg={3} sm={6}>
        <Card
          title={value}
          category={title}
          content={<div className="text-muted">{category}</div>}
        />
      </Col>
    );
  }

  render() {
    const { summary, loginSummary } = this.state;
    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Statystyki systemu"
                category="Dane dostępne wyłącznie dla administratora"
                content={
                  <Row>
                    <Col sm={4} md={3}>
                      <FormGroup>
                        <ControlLabel>Zakres danych</ControlLabel>
                        <FormControl
                          componentClass="select"
                          value={this.state.period}
                          onChange={this.changePeriod}
                          disabled={this.state.loading}
                        >
                          <option value="24h">Ostatnie 24 godziny</option>
                          <option value="7d">Ostatnie 7 dni</option>
                          <option value="30d">Ostatnie 30 dni</option>
                          <option value="all">Cały okres</option>
                        </FormControl>
                      </FormGroup>
                    </Col>
                    <Col sm={4} md={3}>
                      <Button
                        bsStyle="info"
                        onClick={this.loadStatistics}
                        disabled={this.state.loading}
                        style={{ marginTop: 25 }}
                      >
                        {this.state.loading ? "Pobieranie…" : "Odśwież"}
                      </Button>
                    </Col>
                  </Row>
                }
              />
            </Col>
          </Row>

          {this.state.error && (
            <ViewportAlert
              bsStyle="danger"
              onDismiss={() => this.setState({ error: "" })}
            >
              {this.state.error}
            </ViewportAlert>
          )}

          <Row>
            {this.renderMetric(
              "Pomiary analogowe",
              this.formatNumber(summary.measurements),
              "Liczba rekordów w wybranym okresie"
            )}
            {this.renderMetric(
              "Pakiety urządzeń",
              this.formatNumber(summary.messages),
              `${this.formatNumber(summary.active_devices)} aktywnych urządzeń`
            )}
            {this.renderMetric(
              "Błędy transmisji",
              this.formatNumber(summary.transmission_error_events),
              `Suma com_f: ${this.formatNumber(
                summary.transmission_error_total
              )}`
            )}
            {this.renderMetric(
              "Logowania",
              this.formatNumber(loginSummary.login_count),
              `${this.formatNumber(loginSummary.unique_users)} użytkowników`
            )}
          </Row>

          <Row>
            <Col md={12}>
              <Card
                title="Statystyki urządzeń"
                category={`Średni czas odpowiedzi serwera: ${this.formatDecimal(
                  summary.average_response_time,
                  " ms"
                )}; maksymalny uptime: ${this.formatUptime(
                  summary.maximum_uptime
                )}`}
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table hover>
                    <thead>
                      <tr>
                        {this.sortableDeviceHeader("Urządzenie", "device")}
                        {this.sortableDeviceHeader(
                          "Pomiary",
                          "measurement_count"
                        )}
                        {this.sortableDeviceHeader("Pakiety", "message_count")}
                        {this.sortableDeviceHeader(
                          "Błędy com_f",
                          "transmission_error_events"
                        )}
                        {this.sortableDeviceHeader(
                          "Śr. odpowiedź",
                          "average_response_time"
                        )}
                        {this.sortableDeviceHeader(
                          "Maks. uptime",
                          "maximum_uptime"
                        )}
                        {this.sortableDeviceHeader(
                          "Śr. wolna pamięć",
                          "average_free_memory"
                        )}
                        {this.sortableDeviceHeader(
                          "Ostatni kontakt",
                          "last_seen"
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {this.sortedDevices().map(device => (
                        <tr key={String(device.id)}>
                          <td>
                            <strong>{device.desc || device.id}</strong>
                            <br />
                            <small>{device.id}</small>
                          </td>
                          <td>
                            {this.formatNumber(device.measurement_count)}
                            <br />
                            <small>
                              wejścia: {this.formatNumber(device.measured_inputs)}
                            </small>
                          </td>
                          <td>{this.formatNumber(device.message_count)}</td>
                          <td>
                            {this.formatNumber(
                              device.transmission_error_events
                            )}
                            <br />
                            <small>
                              suma:{" "}
                              {this.formatNumber(
                                device.transmission_error_total
                              )}
                            </small>
                          </td>
                          <td>
                            {this.formatDecimal(
                              device.average_response_time,
                              " ms"
                            )}
                          </td>
                          <td>{this.formatUptime(device.maximum_uptime)}</td>
                          <td>
                            {this.formatDecimal(
                              device.average_free_memory,
                              " B"
                            )}
                          </td>
                          <td>{this.formatDate(device.last_seen)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>

          <Row>
            <Col md={7}>
              <Card
                title="Logowania użytkowników"
                category={`Ostatnie logowanie: ${this.formatDate(
                  loginSummary.last_login
                )}`}
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table hover>
                    <thead>
                      <tr>
                        <th>Login</th>
                        <th>Liczba logowań</th>
                        <th>Ostatnie logowanie</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loginUsers.map((user, index) => (
                        <tr key={`${user.login}-${index}`}>
                          <td>{user.login || "—"}</td>
                          <td>{this.formatNumber(user.login_count)}</td>
                          <td>{this.formatDate(user.last_login)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              />
            </Col>
            <Col md={5}>
              <Card
                title="Logowania według dni"
                category="Maksymalnie 31 ostatnich dni z wybranego okresu"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <Table hover>
                    <thead>
                      <tr>
                        <th>Dzień</th>
                        <th>Logowania</th>
                        <th>Użytkownicy</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loginDaily.map(day => (
                        <tr key={day.day}>
                          <td>{day.day}</td>
                          <td>{this.formatNumber(day.login_count)}</td>
                          <td>{this.formatNumber(day.unique_users)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/views/Statistics.jsx